import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import './../css/main.css';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        var containerfluidstyle = {

        };

        var pageContentStyle = {

        }

        if (this.props.isIframe) {
            containerfluidstyle = {
                padding: "0"
            };

            pageContentStyle = {
                padding: "0",
                maxWidth:"100%"
            };
        }

        return (
        
        <div>
            <NavMenu isIframe={this.props.isIframe} />
                <Container className="page-content" style={pageContentStyle}>
                    <div className="container-fluid" style={containerfluidstyle}>
                    {this.props.children}
                </div>
            </Container>
        </div>
        );
    }
}
